import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#00D9FF"};
  color: ${(p) => (p.color ? "#0A2463" : "#0F172A")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgba(0, 217, 255, 0.2);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid #0891B2;
    background-color: #0891B2;
  }
`;
